import React, { useState, useEffect } from 'react'
import { Row, Col, Button } from 'react-bootstrap';
import {  useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom';
import { LinkContainer } from 'react-router-bootstrap';
import { useReactMediaRecorder } from "react-media-recorder"
import fixWebmDuration from 'webm-duration-fix';
import StudentHeader from '../../components/StudentHeader';
import StudentNavbar from '../../components/StudentNavbar';
import Loader from '../../components/Loader';
import Message from '../../components/Message';

const StudentScreen = () => {

    const mimeType = 'video/webm\;codecs=vp9';
    const navigate = useNavigate();

    const { id } = useParams();

    const [showVideo, setshowVideo] = useState(false);
    const [showRecordButtons, setshowRecordButtons] = useState(true);
    const [showStopButtons, setshowStopButtons] = useState(false);
    const [isRecording, setIsRecording] = useState(false);
    const [timeLeft, setTimeLeft] = useState(300); 

    const { studentInfo } = useSelector((state) => state.authStudent);

    useEffect(() => {
        if(!studentInfo) {
            navigate('/studentlogin')
        }
    }, [navigate, studentInfo])

    const startRec = () => {
        setIsRecording(true);
        setTimeLeft(300); 
    };

    const stopRec = () => {
        setIsRecording(false);
        setTimeLeft(0); 
    };

    useEffect(() => {
        let timer;
        if (isRecording && timeLeft > 0) {
        timer = setTimeout(() => {
            setTimeLeft(timeLeft - 1);
        }, 1000);
        } else if (timeLeft === 0) {
            stopRec();
            stopRecording();
        }
        return () => clearTimeout(timer);
    }, [isRecording, timeLeft]);

    const formatTimeLeft = () => {
        const minutes = Math.floor(timeLeft / 60);
        const seconds = timeLeft % 60;
        return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
    };

    async function getString(mediaBlobUrl) {
        const mediaBlob = await fetch(mediaBlobUrl)
            .then(response => response.blob());
                const fixBlob = await fixWebmDuration(new Blob([mediaBlob], { type: mimeType }));     
                var fd = new FormData();
                fd.append('upl', fixBlob);
                fd.append('id', id);
                fetch('/api/upload',
                {
                    method: 'post',
                    body:fd                    
                })  
    }

    const { status, startRecording, stopRecording, mediaBlobUrl } = useReactMediaRecorder(
        {             
            video: true,
            screen: true, 
            onStart: () => {
                setshowStopButtons(true)
                setshowRecordButtons(false)
                startRec()
            },
            onStop: (blobUrl, blob) => {
                getString(blobUrl) 
                setshowVideo(true)
                setshowRecordButtons(false)
                setshowStopButtons(false)
                stopRec();
            }            
        });

  return (
    <div>
        <StudentNavbar />
        <div className="main-content" id="panel">
            <StudentHeader />
            <div className="container-fluid mt--6">
                <div className="row">
                {showRecordButtons ? ( 
                    <>
                    <div >
                        <div className="offset-xl-1 col-xl-10">   
                            <h5 className="h3 card-title mb-0 mycard">
                            <h4 className="tittleColor4 recordTittle">
                                Click on Record Screen  and choose a tab or entire screen to start recording                                
                            <h6 className="tittleColor4 ">
                                (You can record up to 5 minutes of video)
                            </h6>
                            </h4>

                            <br /> 
                            </h5>
                        </div>
                    </div>
                        <div className="offset-xl-4 col-xl-4 " onClick={startRecording}>   
                            <div className="card rounded-pill mouseP">
                            <div className="card-body recordVid33">
                            <div className="row">
                                <div className="sidenav-header recordButt33 col-xl-4" >
                                    <img src="../../assets/img/rec3.png" className="navbar-brand-img recordButt33 recordButt334"  style={{ height: "100%"}}  />
                                </div>
                                <div className="col recordButton33 col-xl-8">
                                    <span  className="h2 font-weight-bold mb-0 tittleColor4 recordButton33 recordVid332">Record Screen</span>
                                </div>
                            </div>
                            </div>
                            </div>
                        </div>
                    </>
                ) : ( 
                    <p></p>
                )} 
                {showStopButtons ? ( 
                    <div className="">
                        <div className="offset-xl-3 col-xl-6 recordButt35">   
                            <div className="sidenav-header   recordButt2" >
                                <img src="../../assets/img/rec4.gif" className="navbar-brand-img recordButt2 recordButt23"  style={{ height: "400%"}}  />
                            </div><br /><br /><br /><br />
                            {isRecording && <p className='timeLeft'>Time Left: {formatTimeLeft()}</p>}
                             {/* <p className='timeLeft '>Time Left: 04:18</p> */}
                            <br /><br /><br />
                        </div>
                        <div className="offset-xl-4 col-xl-4 " onClick={stopRecording}>   
                            <div className="card rounded-pill  mouseP recordSec">
                            <div className="card-body recordVid34">
                            <div className="row ">
                            <div className="sidenav-header  recordButt33 col-xl-4" >
                                <img src="../../assets/img/stop1.png" className="navbar-brand-img recordButt33"  style={{ height: "90%"}}  />
                            </div>
                            <div className="col  col-xl-8 stopR">
                                <span  className="h5 font-weight-bold mb-0 stopR2 tittleColor4  recordVid333">Stop recording</span>
                            </div>
                            </div>
                            </div>
                            </div>
                        </div>
                    </div>  
                ) : ( 
                    <p></p>
                )} 
                {showVideo ? ( 
                    <div className="col-xl-10 offset-xl-1"> 
                        <br /><br /><br /><br />  
                        <div className="card mycard">
                        <video className="card-img-top" src={mediaBlobUrl} controls autoPlay loop />
                        <div className="card-body "><br /><br />
                        <LinkContainer to={`/studentasktype/${id}`} className='btn btn-danger '>
                            <Button variant="primary  bg-gradient-danger" className=' btn btn-primary btn-lg  rounded-pill bg-gradient-info' > &nbsp; Record Again &nbsp; </Button>
                        </LinkContainer>&nbsp; &nbsp;
                        <LinkContainer to={`/studentnewanswer`} className='btn btn-success '>
                            <Button variant="primary  bg-gradient-success" className=' btn btn-primary btn-lg  rounded-pill bg-gradient-success'>&nbsp; Save Video &nbsp; </Button>
                        </LinkContainer>                    
                        </div>
                        </div>
                    </div>
                ) : ( <p></p> )}                 
                </div>
            </div>
        </div>
    </div>
  )
}

export default StudentScreen
